import AccessToken from './AccessToken';
import UserSession from './UserSession';
export default class User {
  constructor(data) {
    if (data == null || data.email == null && data.username == null) {
      throw new Error('Username or Email is required.');
    }
    if (!data.md5) {
      throw new Error('Please provide MD5 hash function');
    }
    this.md5 = data.md5;
    this.authService = data.authService;
    this.email = data.email && data.email.toLowerCase().trim() || null;
    this.username = data.username || this.email && this.md5(this.email).toString();
    this.requiresPassword = data.requiresPassword || false;
    this.session = null;
    this.refreshTtl = data.refreshTtl || 0;
    this.storage = data.storage;
    // keys
    this.keyPrefix = data.authService.keyPrefix;
    this.lastUserKey = data.authService.lastUserKey;
    this.keyPrefixWithUsername = `${this.keyPrefix}.${this.username}`;
    this.accessTokenKey = `${this.keyPrefixWithUsername}.access-token`;
  }
  createSession(accessToken) {
    if (!accessToken) {
      return false;
    }
    const sessionData = {
      accessToken: new AccessToken(accessToken),
      refreshTtl: this.refreshTtl
    };
    return new UserSession(sessionData);
  }
  async getSession() {
    if (!this.username) {
      return null;
    }
    if (this.session && this.session.isValid()) {
      return this.session;
    }
    await this.setSessionFromStorage();
    if (this.session) {
      return this.session;
    }
    return null;
  }
  async setSessionFromStorage() {
    const accessToken = await this.storage.getItem(this.accessTokenKey);
    if (!accessToken) {
      return false;
    }
    const cachedSession = this.createSession(accessToken);
    if (cachedSession && cachedSession.isValid()) {
      await this.setSession(cachedSession);
      return this.session;
    }
    if (cachedSession.canRefresh()) {
      const refreshToken = await this.refreshSession(accessToken);
      const refreshSession = this.createSession(refreshToken);
      if (refreshSession && refreshSession.isValid()) {
        await this.setSession(refreshSession);
        return this.session;
      }
    }
    return false;
  }
  async refreshSession(accessToken) {
    return await this.authService.refreshToken(accessToken);
  }
  setRequiresPassword(requiresPassword = true) {
    this.requiresPassword = requiresPassword;
  }
  async setSession(session) {
    this.session = session;
    await this.cacheUserTokens();
  }
  async cacheUserTokens() {
    await this.storage.setItem(this.accessTokenKey, this.session.getAccessToken().getToken());
    await this.storage.setItem(this.lastUserKey, this.username);
  }
  async clearUserTokens() {
    await this.storage.removeItem(this.accessTokenKey);
    await this.storage.removeItem(this.lastUserKey);
  }
}